/* AuraSupps — shared behaviour for the aura-* homepage sections.
   Extracted from the old monolithic aura-home.liquid. Every routine is
   idempotent and re-runs on shopify:section:load so the theme editor
   stays correct when a single section is re-rendered. */
(function () {
  if (window.__auraHome) return;
  window.__auraHome = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  /* ---------- reveal on view ---------- */
  var revealIO = null;
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); }
        });
      }, { threshold: .16 });
    }
    document.querySelectorAll('.reveal:not([data-aura-seen])').forEach(function (el) {
      el.setAttribute('data-aura-seen', '1');
      revealIO.observe(el);
    });
  }

  /* ---------- leaveout strike ---------- */
  function initLeaveout() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('.leaveout:not([data-aura-lo])').forEach(function (lo) {
      lo.setAttribute('data-aura-lo', '1');
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('in'); });
      }, { threshold: .4 }).observe(lo);
    });
  }

  /* ---------- time rail ---------- */
  var railBound = false;
  function initRail() {
    var tnow = document.getElementById('tnow');
    var fill = document.getElementById('fill');
    if (!tnow || !fill) return;
    var onScroll = function () {
      var stamps = [].slice.call(document.querySelectorAll('[data-time]'));
      if (!stamps.length) return;
      var p = window.scrollY / ((document.body.scrollHeight - window.innerHeight) || 1);
      fill.style.height = (p * 100).toFixed(1) + '%';
      var mid = window.scrollY + window.innerHeight * 0.5;
      var cur = stamps[0];
      for (var i = 0; i < stamps.length; i++) { if (stamps[i].offsetTop <= mid) cur = stamps[i]; }
      if (cur && cur.dataset.time) tnow.textContent = cur.dataset.time;
    };
    if (!railBound) {
      railBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('scroll', onScroll, true);
    }
    onScroll();
  }

  /* ---------- parallax on chapter art ---------- */
  var plxBound = false, ticking = false;
  function para() {
    var vh = window.innerHeight;
    document.querySelectorAll('.ch-art img').forEach(function (img) {
      var r = img.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var c = (r.top + r.height / 2) - vh / 2;
      img.style.transform = 'translateY(' + (c * -0.07).toFixed(1) + 'px)';
    });
    ticking = false;
  }
  function initParallax() {
    if (!plxBound) {
      plxBound = true;
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(para); }
      }, { passive: true });
    }
    para();
  }

  /* ---------- rating count-up ---------- */
  function initCountUp() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('.proof .big:not([data-aura-count])').forEach(function (big) {
      big.setAttribute('data-aura-count', '1');
      var tnode = big.firstChild;
      if (!tnode) return;
      var target = parseFloat(big.getAttribute('data-target') || tnode.textContent) || 0;
      if (!target) return;
      new IntersectionObserver(function (es, ob) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var v = 0;
          var step = target / 37;
          var t = setInterval(function () {
            v += step;
            if (v >= target) { v = target; clearInterval(t); }
            tnode.textContent = v.toFixed(1);
          }, 22);
          ob.unobserve(e.target);
        });
      }, { threshold: .6 }).observe(big);
    });
  }

  /* ---------- sparkles ---------- */
  var NS = 'http://www.w3.org/2000/svg';
  var SPK_D = 'M9.82531 0.843845C10.0553 0.215178 10.9446 0.215178 11.1746 0.843845L11.8618 2.72026C12.4006 4.19229 12.3916 6.39157 13.5 7.5C14.6084 8.60843 16.8077 8.59935 18.2797 9.13822L20.1561 9.82534C20.7858 10.0553 20.7858 10.9447 20.1561 11.1747L18.2797 11.8618C16.8077 12.4007 14.6084 12.3916 13.5 13.5C12.3916 14.6084 12.4006 16.8077 11.8618 18.2798L11.1746 20.1562C10.9446 20.7858 10.0553 20.7858 9.82531 20.1562L9.13819 18.2798C8.59932 16.8077 8.60843 14.6084 7.5 13.5C6.39157 12.3916 4.19225 12.4007 2.72023 11.8618L0.843814 11.1747C0.215148 10.9447 0.215148 10.0553 0.843814 9.82534L2.72023 9.13822C4.19225 8.59935 6.39157 8.60843 7.5 7.5C8.60843 6.39157 8.59932 4.19229 9.13819 2.72026L9.82531 0.843845Z';
  var SPK_COLS = ['#e3ff74', '#a48fff'];
  function initSparkles() {
    document.querySelectorAll('.sparkles:not([data-aura-spk])').forEach(function (el) {
      el.setAttribute('data-aura-spk', '1');
      var count = +(el.dataset.spk) || 9;
      for (var i = 0; i < count; i++) {
        var s = document.createElementNS(NS, 'svg');
        s.setAttribute('viewBox', '0 0 21 21');
        s.setAttribute('class', 'spk');
        var p = document.createElementNS(NS, 'path');
        p.setAttribute('d', SPK_D);
        p.setAttribute('fill', SPK_COLS[Math.random() > 0.5 ? 0 : 1]);
        s.appendChild(p);
        (function (node) {
          var place = function () {
            node.style.left = (Math.random() * 100) + '%';
            node.style.top = (Math.random() * 100) + '%';
            node.style.setProperty('--s', (Math.random() * 0.9 + 0.4).toFixed(2));
            node.style.animationDelay = (Math.random() * 2).toFixed(2) + 's';
          };
          place();
          node.addEventListener('animationiteration', function () { if (Math.random() > 0.7) place(); });
        })(s);
        el.appendChild(s);
      }
    });
  }

  /* ---------- publish the fixed topbar's real height ----------
     The hero pads itself by --aura-topbar-h so it always clears the fixed bar.
     The CSS fallback covers first paint; this makes it exact and keeps it right
     when the promo text wraps to two lines or the bar is hidden entirely. */
  var barBound = false;
  function syncTopbarHeight() {
    var bar = document.querySelector('.aura-root .aura-topbar');
    var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--aura-topbar-h', h + 'px');
  }
  function initTopbarHeight() {
    syncTopbarHeight();
    if (barBound) return;
    barBound = true;
    window.addEventListener('resize', syncTopbarHeight, { passive: true });
    if ('ResizeObserver' in window) {
      var bar = document.querySelector('.aura-root .aura-topbar');
      if (bar) new ResizeObserver(syncTopbarHeight).observe(bar);
    }
  }

  /* ---------- nav: solid state + mobile menu ---------- */
  var navBound = false;
  function initNav() {
    var navEl = document.getElementById('nav');
    var sentinel = document.querySelector('.aura-top-sentinel');
    if (navEl && sentinel && !navEl.hasAttribute('data-aura-nav')) {
      navEl.setAttribute('data-aura-nav', '1');
      // The page scrolls on window OR on an inner container (storefront vs theme-editor
      // iframe), so never trust window.scrollY — drive everything off the sentinel's
      // geometry, which is correct for any scroller.
      var syncNav = function () {
        navEl.classList.toggle('solid', sentinel.getBoundingClientRect().top < -40);
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function () { syncNav(); }, { threshold: [0, 1] }).observe(sentinel);
      }
      if (!navBound) {
        navBound = true;
        window.addEventListener('scroll', syncNav, { passive: true });
        document.addEventListener('scroll', syncNav, true);
      }
      syncNav();

      var burger = navEl.querySelector('.nav-burger');
      if (burger) {
        burger.addEventListener('click', function () {
          var open = navEl.classList.toggle('menu-open');
          burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        navEl.querySelectorAll('menu a').forEach(function (a) {
          a.addEventListener('click', function () { navEl.classList.remove('menu-open'); });
        });
      }
    }
  }

  /* ---------- cart: add-to-cart + drawer ---------- */
  function openDrawer() {
    if (window.auraOpenCart) { window.auraOpenCart(); return; }
    var d = document.querySelector('cart-drawer');
    if (d) {
      d.classList.add('aura-open', 'active', 'animate');
      document.body.classList.add('overflow-hidden');
    } else {
      window.location.href = ROOT + 'cart';
    }
  }
  function applySections(sections) {
    if (sections['cart-drawer']) {
      var p = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var ni = p.querySelector('.drawer__inner');
      var d = document.querySelector('cart-drawer');
      var ci = d ? d.querySelector('.drawer__inner') : null;
      if (ni && ci) ci.replaceWith(ni);
      if (d) d.classList.remove('is-empty');
    }
    if (sections['cart-icon-bubble']) {
      var live = document.getElementById('cart-icon-bubble');
      if (live) {
        var rd = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var s = rd.getElementById('cart-icon-bubble');
        if (s) live.innerHTML = s.innerHTML;
      }
    }
  }
  function updateNavCount() {
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.nav-cart').forEach(function (el) {
        el.textContent = (el.getAttribute('data-label') || 'Кошница') + ' · ' + c.item_count;
      });
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var openEl = e.target.closest && e.target.closest('[data-aura-cart]');
    if (openEl) { e.preventDefault(); openDrawer(); return; }
    var add = e.target.closest && e.target.closest('[data-aura-add]');
    if (!add) return;
    var n = parseInt(add.getAttribute('data-aura-add'), 10);
    if (!n) return; // no valid variant -> let the link's href work (scroll)
    e.preventDefault();
    if (add.getAttribute('data-busy')) return;
    add.setAttribute('data-busy', '1');
    add.style.opacity = '.65';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: n, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        add.removeAttribute('data-busy');
        add.style.opacity = '';
        if (!data || data.status) return;
        applySections(data.sections || {});
        updateNavCount();
        openDrawer();
      })
      .catch(function () { add.removeAttribute('data-busy'); add.style.opacity = ''; });
  });

  /* ---------- boot ---------- */
  function init() {
    initTopbarHeight();
    initNav();
    initReveal();
    initLeaveout();
    initRail();
    initParallax();
    initCountUp();
    initSparkles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor re-renders one section at a time — re-run against the new DOM.
  document.addEventListener('shopify:section:load', init);
})();
